module.exports = __webpack_public_path__ + "img/logo_fra.1b4bdd81.svg";